import { gettext } from '@eventbrite/i18n';
import { Typography, TypographyProps } from '@eventbrite/marmalade';
import React from 'react';
import { FormattedEvent } from '../../types/events';

type EventCardPricePropsFormattedEvent = Pick<
    FormattedEvent,
    'formattedPriceString' | 'isFree'
>;

type ExtendedEventCardPriceProps = EventCardPricePropsFormattedEvent &
    Omit<TypographyProps, 'children'>;

const FREE_COPY = gettext('Free');

export const EventCardPrice: React.FunctionComponent<
    ExtendedEventCardPriceProps
> = (props) => {
    const { formattedPriceString, isFree, ...typographyProps } = props;

    if (isFree) {
        return <Typography {...typographyProps}>{FREE_COPY}</Typography>;
    }

    if (formattedPriceString) {
        return (
            <Typography {...typographyProps}>{formattedPriceString}</Typography>
        );
    }

    //TODO: Support loading/placeholder state for price component so that we can
    //render something while waiting for client fetched data to resolve.
    //https://eventbrite.atlassian.net/browse/EB-222873

    return null;
};
